import React from "react";
import { IconProps } from "../constants/GlobalTypesAndEnumsAndConstants";

const IconLightningOutline = (props: IconProps) => (
  <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.43323 1.66927L2.35923 6.33594H4.65723C5.11723 6.33594 5.44123 6.78594 5.2959 7.2226L4.1919 10.5339L9.05723 5.66927H7.3439C7.22911 5.66925 7.11624 5.63988 7.016 5.58396C6.91577 5.52804 6.83149 5.44743 6.77117 5.34977C6.71085 5.25211 6.6765 5.14066 6.67138 5.02599C6.66625 4.91132 6.69053 4.79725 6.7419 4.6946L8.25456 1.66927H4.43323ZM3.38923 0.735937C3.49723 0.492604 3.7379 0.335938 4.00456 0.335938H9.32256C9.82256 0.335938 10.1486 0.862604 9.92456 1.3106L8.4119 4.33594H10.6506C11.2506 4.33594 11.5506 5.06127 11.1266 5.48527L3.1579 13.4539C2.65523 13.9566 1.8179 13.4393 2.04323 12.7653L3.7419 7.66927H1.34323C1.23106 7.66927 1.12067 7.64124 1.02208 7.58774C0.923493 7.53423 0.839835 7.45695 0.778703 7.3629C0.717572 7.26885 0.680905 7.16102 0.672032 7.0492C0.663159 6.93738 0.682362 6.82512 0.727896 6.7226L3.38923 0.735937Z"
      fill="currentColor"
    />
  </svg>
);

export default IconLightningOutline;
